import React from 'react'
import './Heading.scss';

export default function Heading() {
  return (
    <div className="pricing-heading-container">
      <h2>How to earn M Coins and make use them</h2>
      <p>We offer multiple ways to collect M Coins:</p>
    </div>
  )
}
